export default __webpack_public_path__ + "static/media/Ballroll_00136.51f17dd5.png";